"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = exports.arp = exports.progression = exports.getChordsByProgression = exports.getChordDegrees = exports.clip = exports.chords = exports.chord = exports.modes = exports.scales = exports.mode = exports.scale = void 0;
var harmonics_1 = require("harmonics");
Object.defineProperty(exports, "scales", { enumerable: true, get: function () { return harmonics_1.scales; } });
Object.defineProperty(exports, "modes", { enumerable: true, get: function () { return harmonics_1.scales; } });
Object.defineProperty(exports, "chords", { enumerable: true, get: function () { return harmonics_1.chords; } });
Object.defineProperty(exports, "scale", { enumerable: true, get: function () { return harmonics_1.scale; } });
Object.defineProperty(exports, "mode", { enumerable: true, get: function () { return harmonics_1.scale; } });
Object.defineProperty(exports, "chord", { enumerable: true, get: function () { return harmonics_1.chord; } });
var clip_1 = require("./clip");
Object.defineProperty(exports, "clip", { enumerable: true, get: function () { return clip_1.clip; } });
var progression_1 = require("./progression");
Object.defineProperty(exports, "getChordDegrees", { enumerable: true, get: function () { return progression_1.getChordDegrees; } });
Object.defineProperty(exports, "getChordsByProgression", { enumerable: true, get: function () { return progression_1.getChordsByProgression; } });
Object.defineProperty(exports, "progression", { enumerable: true, get: function () { return progression_1.progression; } });
var arp_1 = require("./arp");
Object.defineProperty(exports, "arp", { enumerable: true, get: function () { return arp_1.arp; } });
var max_1 = require("./max");
Object.defineProperty(exports, "max", { enumerable: true, get: function () { return max_1.max; } });
__exportStar(require("./types"), exports);
